var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('overlay-loader',{attrs:{"overlay":true}}),(_vm.alert)?_c('span',{staticClass:"alert"},[_c('v-icon',{staticClass:"alertIcon"},[_vm._v("mdi-alert")]),_vm._v(" "+_vm._s(_vm.alertMessage)+" ")],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }